import { observer } from 'mobx-react'
import { ReactComponent as GreenCircle } from '../../../../assets/things/green-circle.svg'
import { ReactComponent as RedCircle } from '../../../../assets/things/red-circle.svg'
import { ReactComponent as GreenMark } from '../../../../assets/things/Group 48095685 (1).svg'
import { ReactComponent as RedMark } from '../../../../assets/things/Group 48095686 (1).svg'

import { ReactComponent as GreenLightCircle } from '../../../../assets/things/light-green.svg'
import { ReactComponent as RedLightCircle } from '../../../../assets/things/light-red.svg'
import { ReactComponent as ArrowRight } from '../../../../assets/things/arrow-right.svg'

import './index.scss'
import classNames from 'classnames'
import { useLocation } from 'react-router'
import { useEffect } from 'react'
const ThingsCan = observer(({ content }: { content: any }) => {
  const { pathname } = useLocation()
  return (
    <div
      className={classNames(
        'things-can',
        // pathname.includes('business') && 'dark-theme',
      )}
    >
      <div className="things-can__row">
        <div className="things-can__col">
          <div className="things-can__col-title">
            {' '}
            <GreenMark /> {content.title}
          </div>
          <div className="things-can__subtitle">{content.possible.title}</div>
          <div className="things-can__list">
            {content.possible.list.map((p: any, i: number) => (
              <div className="things-can__item" key={i}>
                <div className="things-can__item-img">
                  {!pathname.includes('business') ? (
                    <GreenCircle />
                  ) : (
                    <GreenLightCircle />
                  )}
                  <img src={p.icon} />
                </div>
                <div className="things-can__item-title">{p.title}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="things-can__col">
          <div className="things-can__col-title">
            <RedMark />
            {content.title2}
          </div>
          <div className="things-can__subtitle">{content.impossible.title}</div>
          <div className="things-can__list">
            {content.impossible.list.map((p: any, i: number) => (
              <div className="things-can__item small" key={i}>
                <div className="things-can__item-img">
                  {!pathname.includes('business') ? (
                    <RedCircle />
                  ) : (
                    <RedLightCircle />
                  )}
                  <img src={p.icon} />
                </div>
                <div className="things-can__item-title small">{p.title}</div>
              </div>
            ))}
          </div>
          <div className="things-can__btns">
            {content?.arraylink?.map((c: any, i: number) => (
              <a
                className="button grey-border things-can__link "
                href={c.link}
                target="_blank"
                rel="noreferrer"
                key={i}
              >
                {c.name} <ArrowRight />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
})
export default ThingsCan
